import { gql } from "apollo-angular";

const FILTER_TENSION = gql`query Tension(
	$company: ID!
) {
	getTension(
		companyId: $company
	) {
		message
		tension{
			highTension
			lowTension
		}
	}
}`;

const CREATE_TENSION = gql`mutation CreateTension(
	$company: ID!,
	$high_tension: Float!,
	$low_tension: Float!
) {
	createTension(
		input: {
			companyId: $company
			highTension: $high_tension
			lowTension: $low_tension
		}) {
		message
		tension{
			highTension
			lowTension
		}
	}
}`

const UPDATE_TENSION = gql`mutation UpdateTension(
	$company: ID!,
	$high_tension: Float!,
	$low_tension: Float!
) {
	updateTension(
		input: {
			companyId: $company
			highTension: $high_tension
			lowTension: $low_tension
		}) {
		message
		tension{
			highTension
			lowTension
		}
	}
}`

const DELETE_TENSION = gql`mutation DeleteTension(
	$company: ID!
) {
	deleteTension(
		input: {
			companyId: $company
		}) {
		message
	}
}`

export {
  // Queries
  FILTER_TENSION,
  // Mutations
  CREATE_TENSION,
  UPDATE_TENSION,
  DELETE_TENSION
}
